import { Box, BoxProps, Text } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import {
  formFooterHeight,
  fullHDScreenWidth,
  headerHeight,
  rightPanelExpandedWidth,
  rightPanelWidth,
} from '~/utilities';
export interface ButtonComponentProps {
  disabled?: boolean;
}
interface RightPanelStyledProps {
  isCollapsed: boolean;
}
export const FeedbackMainContainerStyled = styled(Box).attrs({
  p: { sm: '400' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    height: calc(100vh - ${headerHeight + formFooterHeight}px);
    background-color: ${theme.colors.grey[100]};
  `}
`;

export const FeedbackCardStyled = styled(Box).attrs({
  p: { sm: '500' },
  flexGrow: { sm: '1' },
})`
  ${({ theme }) => css`
    border-radius: ${theme.radii[400]};
    background-color: white;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `}
`;

export const FormContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: 72%;
`;
export const CheckboxLabelStyled = styled(Text).attrs({
  weight: '400',
  size: '300',
})<ButtonComponentProps>`
  ${({ theme, disabled }) => css`
    color: ${disabled && theme.colors.grey[400]};
    margin-left: ${theme.spacings[300]};
    align-self: center;
    margin-top: ${theme.spacings[100]};
  `};
`;

export const RightPanelStyled = styled(Box)<BoxProps & RightPanelStyledProps>`
  overflow: auto;
  height: calc(100vh - ${headerHeight}px);
  overflow-y: auto;
  transition: all 0.3s;
  ${({ theme, isCollapsed }) => css`
    width: ${isCollapsed ? rightPanelWidth : 0}px;
    box-shadow: ${theme.componentStyles.boxShadow};
    @media only screen and (min-width: ${fullHDScreenWidth}) {
      width: ${isCollapsed ? rightPanelExpandedWidth : 0}px;
    }
  `}
`;

export const CableMarkHeaderStyled = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border: 1px solid ${theme.colors.grey[300]};
  `}
`;
